import { render, staticRenderFns } from "./formHeader.vue?vue&type=template&id=6c5ad102&scoped=true"
import script from "./formHeader.vue?vue&type=script&lang=js"
export * from "./formHeader.vue?vue&type=script&lang=js"
import style0 from "./formHeader.vue?vue&type=style&index=0&id=6c5ad102&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5ad102",
  null
  
)

export default component.exports